<template>

<div>

    <vue-scroll :ops="this.$root.shared.scrollops">

<!--            <div class="pb-20 scrolling-touch vld-parent" ref="mainContainer">-->
        <div class="scrolling-touch vld-parent" ref="mainContainer">

            <div v-if="!smartphone">

                <hero-content-section v-if="herocontent" :currentlocale="currentlocale" :herocontent="herocontent" :bkg_urls="bkg_urls" :extra_links="extra_links" :complementary_content="complementary_content"></hero-content-section>

                <hr class="mb-2" />

                <content-section :sectiontitle_es="translate('cat_featured')" :sectiontitle_en="translate('cat_featured')" filter="8" contentCount="12" :currentlocale="currentlocale" :default_thumbnail="default_thumbnail"></content-section>

                <transition-group name="anim-modules">
                <content-section v-for="category in contentCounts" v-if="userPrefArray.includes(category.id) && category.count!==0 && category.id!==8" v-bind:key="category.id"
                                 contentCount="12" class="anim-modules-item"
                                 :category_id="category.id"
                                 :sectiontitle_es="category.name" :sectiontitle_en="category.name_en"
                                 :filter="category.id"
                                 :currentlocale="currentlocale"
                                 :default_thumbnail="default_thumbnail"
                                 :controls_enabled="{ true : category.id !== 8 }"
                >
                </content-section>
                </transition-group>

            </div>

            <div v-if="smartphone">

                <mobile-hero-content-section v-if="herocontent" :currentlocale="currentlocale" :herocontent="herocontent" :bkg_urls="bkg_urls" :extra_links="extra_links" :complementary_content="complementary_content"></mobile-hero-content-section>

                <mobile-content-section :sectiontitle_es="translate('cat_featured')" :sectiontitle_en="translate('cat_featured')" filter="8" contentCount="12" :currentlocale="currentlocale" :default_thumbnail="default_thumbnail"></mobile-content-section>

                <mobile-content-section v-for="category in contentCounts" v-if="category.count!==0 && category.id!==8" v-bind:key="category.id" contentCount="12"
                                        :sectiontitle_es="category.name" :sectiontitle_en="category.name_en" :filter="category.id" :currentlocale="currentlocale" :default_thumbnail="default_thumbnail"></mobile-content-section>

            </div>

            <flash-message :position="'right top'" style="z-index: 999999999; pointer-events: none;" class="p-6"></flash-message>

        </div>

        <div v-if="!smartphone" class="w-full bg-theme-level4 border-b border-theme-level2">
            <div id="sectionHeader" class="p-6 border-b border-theme-level2 flex flex-row items-center justify-between">
                <h2 class="text-theme-discrete font-bold text-xl cursor-pointer">{{ translate('all-content-ordered') }}</h2>
                <div id="section-controls">
                    <i id="section-info-config" class="material-icons mr-2 cursor-pointer w-4 h-4 text-theme-xmuted hover:text-theme-muted invisible" style="font-size: 20px;">settings</i>
                    <i id="section-info-control" class="material-icons mr-2 cursor-pointer w-4 h-4 text-theme-xmuted hover:text-theme-muted invisible" style="font-size: 20px;">info_outline</i>
                    <i id="section-config-control" class="material-icons mr-2 cursor-pointer w-4 h-4 text-theme-xmuted hover:text-theme-muted invisible" style="font-size: 20px;">highlight_off</i>
                </div>
            </div>

            <explore-content-section
                :currentlocale="currentlocale"
                category_id="0"
                sub_category_id="0"
                :default_thumbnail="default_thumbnail"
            >
            </explore-content-section>

        </div>

    </vue-scroll>

</div>

</template>

<script>

    import { isMobileOnly } from 'mobile-device-detect';
    import { isTablet } from 'mobile-device-detect';

    const Lang = require('lang.js');
    import translations from './messages.js';

    const lang = new Lang();

    lang.setMessages(translations);

    export default {

        props: [
            'currentlocale',

            'is_direct_link',
            'content_id',
            'is_legacy',
            'default_thumbnail',
            'herocontent',
            'extra_links',
            'complementary_content',
            'bkg_urls'
        ],

        data() {
            return {

                currentUser: '',

                smartphone: isMobileOnly,
                tabletDevice: isTablet,

                contentCounts: [],

                userPrefArray: ''

            }
        },

        computed: {

        },

        methods: {

            getContentsCounts() {

                axios.get('/api/count/categories/content' + '/' + this.currentlocale)
                    .then(response => {
                        this.contentCounts = response.data;
                    })
                    .catch(error => {
                        this.componentLoading = false;
                        console.log('SERVER ERROR!! --> ' + JSON.stringify(error));
                    });

            },

            translate(key) {
                key = 'strings.' + key;
                return lang.get(key);
            }

        },

        mounted() {

            this.getContentsCounts();
            lang.setLocale(this.currentlocale);

        },

        created() {

            this.currentUser = Laravel.user

            if (this.currentUser !== null) {

                axios.get('/' + this.language + '/prefs/home/get/' + this.currentUser.id)
                    .then(response => {

                        this.userPrefArray = response.data

                    })
                    .catch(error => {

                        console.log('ERROR trying to get the user preferences for the home page')

                    })

            } else {

                // No user authenticated, just return all sections as visible

                axios.get('/prefs/home/get/anon')
                    .then(response => {

                        this.userPrefArray = response.data

                    })
                    .catch(error => {

                        console.log('ERROR trying to get GENERIC prefs for the home page for anon user')

                    })

            }

            if(this.is_direct_link) {

                axios.get('/api/content/' + this.content_id)
                    .then(response => {
                        if (response.data) {
                            Event.fire('showPlayer', {language: this.currentlocale, data: response.data});
                        } else {
                            this.flashMessage.error({
                                title: '',
                                message: this.translate('content-not-found'),
                                blockClass: 'p-6',
                                x: 25,
                                y: 80,
                                time: 3000
                            });
                        }

                    })
                    .catch(error => {
                        console.log('Error from Search Bar: ' + JSON.stringify(error));
                    });

            }



        }
    }
</script>
